import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    error = false;
    errorMessage = '';
    private isLoading = new BehaviorSubject<boolean>(false);

    startLoading() {
        this.error = false;
        this.isLoading.next(true);
    }

    stopLoading() {
        this.isLoading.next(false);
    }
    showError(message: string) {
        this.error = true;
        this.errorMessage = message;
    }
    isLoading$(): Observable<boolean> {
        return this.isLoading.asObservable();
    }
}
